import Component from 'vue-class-component';
import { ContactListAbstract } from '../ContactAbstract/ContactListAbstract';
import ContactTableElement from '../ContactTableElement/ContactTableElement'
@Component({
    components: {
        ContactTableElement
    }
})
export default class ContactTable extends ContactListAbstract {
    headers = [
        {
            text: 'Город',
            sortable: false,
            width: '165'
        },
        {
            text: 'Адрес',
            sortable: false,
        },
        {
            text: 'Телефон',
            sortable: false,
            width: '190'
        },
        {
            text: 'Почта',
            sortable: false,
        },
    ]
}